import Draggable from 'react-draggable';
import {useState, useRef, useEffect, useLayoutEffect} from 'react';

function TimeSlider(props) {

	const dateRange = props.dateRange[1] - props.dateRange[0];

	const [maxRight, setMaxRight] = useState(0);

	const containerRef = useRef(null);

	const leftSliderRef = useRef(null);
	const rightSliderRef = useRef(null);

	const [leftSliderPos, setLeftSliderPos] = useState(0);
	const [rightSliderPos, setRightSliderPos] = useState(0);
	const [startingMouseDownPos, setStartingMouseDownPos] = useState(0);

	const [mouseDown, setMouseDown] = useState(false);

	const [leftBounds, setLeftBounds] = useState({
		left: 0,
		top: 0,
		right: 0,
		bottom: 0
	});

	const [rightBounds, setRightBounds] = useState({
		left: 0,
		top: 0,
		right: 0,
		bottom: 0
	});

	const [tick, setTick] = useState(0);

	const handleStop = (e, data) => {
		e.stopPropagation();
		if (data.node.classList.contains('_sliderLeft')) {
			setLeftSliderPos(e.clientX);
			setRightBounds({...rightBounds, left: -Math.abs(maxRight - data.x)});
			const newStartDate = Math.round(data.x/tick) + props.dateRange[0];
			props.setStartDate(newStartDate);

		};
		if (data.node.classList.contains('_sliderRight')) {
			setRightSliderPos(e.clientX);
			setLeftBounds({...leftBounds, right: props.width + data.x -16});
			const newEndDate = Math.round((props.width + data.x)/tick) + props.dateRange[0];
			props.setEndDate(newEndDate);
		}
	}

	const handleScrub = (e) => {
		// Todo! Possibly re-write - this doesn't work...
		if (mouseDown) {
			const xPos = e.clientX;
			if (xPos > leftSliderPos && xPos < rightSliderPos) {
				let offset = 0;
				const currentLeft = leftSliderRef.current.state.x;
				const currentRight = rightSliderRef.current.state.x;

				if (xPos > startingMouseDownPos) {
					offset = xPos - startingMouseDownPos;
					const newLeftPos = currentLeft + offset;
					const newRightPos = currentRight + offset;

					console.log(currentLeft, currentRight, startingMouseDownPos, offset, leftBounds.right);

					if (newLeftPos > 0 && newLeftPos < leftBounds.right) {
						leftSliderRef.current.setState({x: newLeftPos});	
					}
					if (newRightPos < 0) {
						rightSliderRef.current.setState({x: newRightPos});
					}
				} else if (xPos < startingMouseDownPos) {
					offset = startingMouseDownPos - xPos;
					//console.log(offset);
					//leftSliderRef.current.setState({x: currentLeft + offset});
					//rightSliderRef.current.setState({x: currentRight + offset});
				}
			}
		}	
	}

	useLayoutEffect(() => {
		setMaxRight(props.width -18);
		setRightBounds({...rightBounds, left: -Math.abs(maxRight)});
		setLeftBounds({...leftBounds, right: maxRight});
		setTick((props.width) / dateRange)
	}, [props.width, maxRight]);

	return (
		<div className={`w-full ${props.timeSliderDisabled ? "opacity-50" : ""}`}>
			<div className="text-center p-1">
				<h1 className="font-bold italic">Date Range</h1>
				<p className="text-xs font-thin">{props.startDate}-{props.endDate}</p>
			</div>
			<div className="w-full flex h-4 items-center bg-gray-300 border-2" 
					onMouseDown={(e) => {
						setMouseDown(true);
						setStartingMouseDownPos(e.clientX);
					}} 
					onMouseUp={(e) => {
						setMouseDown(false);
					}} 
					onMouseOut={(e) => {
						setMouseDown(false);
					}}
					onMouseMove={null} 
					ref={containerRef}
				>
				<Draggable axis="x" onStop={handleStop} bounds={leftBounds} ref={leftSliderRef} disabled={props.timeSliderDisabled}>
					<div className="w-2 h-4 bg-gray-500 block hover:cursor-pointer _sliderLeft"></div>
				</Draggable>
				<Draggable axis="x" onStop={handleStop} bounds={rightBounds} positionOffset={{x: maxRight, y:0}} ref={rightSliderRef} disabled={props.timeSliderDisabled}>
					<div className="w-2 h-4 bg-gray-500 block hover:cursor-pointer _sliderRight"></div>
				</Draggable>
			</div>
		</div>
	)
}

export default TimeSlider;